<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-10-09 10:19:22
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2024-01-22 16:53:47
 * @FilePath: \合联\oms\src\view\analysis\gccOrderStatistics\order.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    isTabs
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/analysis/financialRevenue";
export default {
  name: "",
  components: {
    cTable
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    noPage: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default() {
        return {};
      }
    },
    headers: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  mounted() {
    this.header.searchs.splice(
      0,
      0,
      ...this.headers.filter(t => {
        if (t.includes) {
          return t.includes.includes(this.name);
        } else return true;
      })
    );
    this.keys = this.data.keys;
    Object.keys(this.keys).forEach(key => {
      this.fields.push({
        name: this.$tz(this.keys[key].description),
        key: key,
        minWidth: 120
      });
    });
  },
  data() {
    return {
      methods: {
        ...apis,
        list: p => {
          return this.data.list(p);
        },
        beforeHandleList: ({ data }) => {
          if (this.noPage) return data;
          else return data.rows;
        }
      },
      config: {
        tabHeight: -30,
        slot: "div",
        isGetList: true
      },
      modals: {},
      footer: {
        show: () => !this.noPage
      },
      header: {
        config: {
          searchLength: 30
        },
        searchs: [],
        btns: {
          list: [
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary"
              }
            }
          ],
          methods: {
            export: () => {
              let table = this.$refs["table"];
              table.selectAll = table.list;
              table.exportExc(this.$t(this.$route.name) + "-" + this.name);
            },
            detail({ searchForm }) {
              this.handleRequestMethods(
                "list",
                Object.assign({ export: 1 }, searchForm),
                false,
                true
              ).then(res => {
                this.$Message.success(res.msg);
              });
            }
          }
        }
      },
      fields: []
    };
  }
};
</script>

<style scoped></style>
